module.exports = __webpack_public_path__ + "img/54.ab9a0ce9.png";